/**
 * @generated SignedSource<<a767bb155c60b6c9e14a42391bd67cba>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type pickupOneDeliveryQuery$variables = {
  id: string;
};
export type pickupOneDeliveryQuery$data = {
  readonly bundle: {
    readonly hub: {
      readonly id: string;
      readonly meta: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    };
    readonly id: string;
  };
};
export type pickupOneDeliveryQuery = {
  response: pickupOneDeliveryQuery$data;
  variables: pickupOneDeliveryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "HubMeta",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pickupOneDeliveryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Bundle",
        "kind": "LinkedField",
        "name": "bundle",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "kind": "RequiredField",
            "field": (v3/*:: as any*/),
            "action": "THROW"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "pickupOneDeliveryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Bundle",
        "kind": "LinkedField",
        "name": "bundle",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1e69dbde284471bbaa55fe5b2b66fd63",
    "id": null,
    "metadata": {},
    "name": "pickupOneDeliveryQuery",
    "operationKind": "query",
    "text": "query pickupOneDeliveryQuery(\n  $id: UUID!\n) {\n  bundle(id: $id) {\n    id\n    hub {\n      id\n      meta {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "52717a00cb632b59331a61357ca6b48f";

export default node;
